<template>
	<div>
		<loader-component v-if="loading" />
		<div v-else class="d-flex flex-column align-items-center justify-content-center">
			<div v-if="companyUpdated" class="alert alert-success alert-dismissible fade show shadow-sm" :style="'width: -webkit-fill-available'" role="alert">
				<div>Company account changed successfully.</div>
				<button type="button" class="close" data-dismiss="alert" aria-label="Close">
					<span aria-hidden="true">×</span>
				</button>
			</div>

			<div v-if="showIcon" class="justify-content-center">
				<div class="wd-150 wd-sm-150 mg-b-30">
					<img :src="institution" class="img-fluid" alt="" />
				</div>
			</div>

			<h3 class="tx-color-01 mg-b-5 tx-center">Select Company</h3>
			<p class="tx-color-03 tx-13 tx-center">Please select a company to use for this session.</p>

			<form @submit.prevent="selectCompany" class="wd-35p">
				<div class="form-group">
					<select class="custom-select shadow-sm" v-model="company">
						<option :value="null" disabled>Select company</option>
						<option v-for="(companyOption, index) in companies" :key="index" :value="companyOption.id" v-text="companyOption.name"></option>
					</select>
				</div>
				<button-component :label="'Select Company'" :label-loading="'Please wait..'" :button-class="'btn btn-block btn-default '"></button-component>
			</form>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import institution from './../../../../../img/institution.svg';

export default {
	mounted() {
		this.getUserCompanies();
	},
	data() {
		const { company } = this.$store.getters;
		const companyId = !_.isEmpty(company) ? company.id : null;

		return {
			loading: true,
			institution,
			companies: {},
			company: companyId,
			companyUpdated: false,
		};
	},
	computed: {
		showIcon() {
			return this.$route.name !== 'account.settings.change-compaany-account';
		},
	},
	methods: {
		...mapActions({
			setCompany: 'setCompany',
		}),
		getUserCompanies() {
			const user = this.$store.getters.user;
			this.loading = true;

			axios
				.get(`/api/company-users/${user.client.id}/companies`)
				.then(({ data: { data } }) => {
					this.companies = data;

					if(this.showIcon && data.length === 1) {
						this.setCompany(data[0]);
						this.companyUpdated = true;
					}
				})
				.catch(({ response }) => console.log(response))
				.finally(() => (this.loading = false));
		},
		selectCompany() {
			const selectedCompany = this.companies.find((_company) => _company.id === this.company);
			this.setCompany(selectedCompany);
			this.companyUpdated = true;
		},
	},
};
</script>

<style>
</style>